import React, {memo, useState} from 'react';
import {Button, Tooltip} from "reactstrap";

const ActionsColumn = memo(({
                              feedExport,
                              handleToggle,
                              handleRequestExportClick,
                              isRequestExportLoading,
                            }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const tooltipId = `tooltip-url-${feedExport.id}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(feedExport.url).then(() => {
      setTooltipOpen(true);
      setTimeout(() => setTooltipOpen(false), 1500);
    });
  };


  return (<td className='overflow-auto text-break' width={"25%"}>
      <div className='d-flex justify-content-center'>
        <div className={'feed_export_item_actions'}>
          <div className={'feed_export_item_actions_toggle'}>
            <label className="custom-toggle me-1">
              <input type="checkbox" name="status" checked={feedExport.status} onChange={handleToggle}/>
              <span className="custom-toggle-slider rounded-circle"/>
            </label>
          </div>
          <div className={'feed_export_item_actions_buttons'}>
            <div className='tooltip-hover'>
              <Button onClick={handleCopy} className={'btn-icon-only'} id={tooltipId}
                      color={feedExport.status ? 'primary' : 'secondary'}>
                <span className="fa-solid fa-copy"/>
              </Button>
              <Tooltip
                placement="top"
                target={tooltipId}
                trigger="manual"
                isOpen={tooltipOpen}
                delay={{"show": 0, "hide": 100}}
              >
                Copied
              </Tooltip>
              <span className="tooltiptext tooltip-bg">Copy</span>
            </div>
            <div className='tooltip-hover'>
              <a href={feedExport.url} download target="_blank" rel="noreferrer" className={'ms-2'}>
                <Button className={'btn-icon-only'} color={feedExport.status ? 'primary' : 'secondary'}>
                  <span className="fa-solid fa-file-download"/>
                </Button>
              </a>
              <span className="tooltiptext">Download</span>
            </div>
            <div className='tooltip-hover'>
              <Button
                onClick={handleRequestExportClick}
                className='ms-3 btn-icon-only'
                color={feedExport.status ? 'primary' : 'secondary'}
              >
                {
                  isRequestExportLoading ?
                    <span className="spinner-border spinner-border-sm me-1"/>
                    :
                    <span className="fa-solid fa-file-export"/>
                }
              </Button>
              <span className="tooltiptext">Request Export</span>
            </div>
          </div>
        </div>
      </div>
    </td>
  )
});


export default ActionsColumn;
